"use strict";
/**
 * @name Select
 *
 * @description
 *  A common select component for html select elements. Includes support for a label and a generic map function
 *  for options. See teamsnap patterns lib for more information.
 *  https://teamsnap-ui-patterns.netlify.com/patterns/components/select-box.html
 *
 * @example
 *  <Select
 *    name='LineItemFeeCategory'
 *    options={[
 *      {
 *        'label': 'Tournament',
 *        'value': 'tournament'
 *      },
 *      {
 *        'label': 'Other',
 *        'value': 'other'
 *      }
 *    ]} />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
    })).isRequired,
    inputProps: PropTypes.object,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    otherProps: PropTypes.object,
    disabled: PropTypes.bool,
    testId: PropTypes.string,
};
var Select = function (_a) {
    var name = _a.name, options = _a.options, inputProps = _a.inputProps, className = _a.className, mods = _a.mods, style = _a.style, otherProps = _a.otherProps, disabled = _a.disabled, testId = _a.testId;
    var renderOptions = function (option) {
        var label = option.label, value = option.value, disabledProp = option.disabled;
        return (React.createElement("option", { key: value, value: value, disabled: disabledProp }, label));
    };
    return (React.createElement("div", __assign({ className: (0, helpers_1.getClassName)(className, mods), style: style, "data-testid": testId }, otherProps),
        React.createElement("select", __assign({ className: "SelectBox-options", name: name, id: name, disabled: disabled }, inputProps), options.map(renderOptions))));
};
Select.defaultProps = {
    inputProps: {},
    className: 'SelectBox',
    mods: null,
    style: {},
    testId: null,
    otherProps: {},
};
exports.default = Select;
